import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { EMPTY, Subscription } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { SatisfactionConfigService } from 'src/app/services/satisfaction-services/satisfaction-config-service/satisfaction-config.service';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';

@Component({
  selector: 'app-satisfaction-config-satisfaction-card',
  templateUrl: './satisfaction-config-satisfaction-card.component.html',
  styleUrls: ['./satisfaction-config-satisfaction-card.component.scss']
})
export class SatisfactionConfigSatisfactionCardComponent implements OnInit, OnChanges {

  @Input() active;
  updateSatisfactionsConfigSatisfactionSubscription: Subscription;

  basicDataForm = new FormGroup({
    satisfaction: new FormControl(null, Validators.required)
  });

  constructor(private satisfactionConfigService: SatisfactionConfigService,
              private snackbarService: SnackBarService) {}

  ngOnInit() {}

  ngOnChanges() {
    if ((this.active === true) || (this.active === false)) {
      this.resetForm();
    }
  }

  public submitForm(e) {
    this.updateSatisfactionsConfigSatisfactionSubscription = this.satisfactionConfigService.updateSatisfactionConfigSatisfaction(this.basicDataForm.get('satisfaction').value).pipe(
      tap(o => this.satisfactionConfigService.refreshSatisfactionsConfig()),
      catchError(error => {
        this.snackbarService.open(error['data']['error'], 'error');
        this.satisfactionConfigService.refreshSatisfactionsConfig();
        return EMPTY; })
    ).subscribe();
  }

  public resetForm() {
    this.basicDataForm.patchValue({
      satisfaction: this.active
    });
  }

}
